export default {
  ru: {
    menu: {
      title_1: 'Привлечение клиентов',
      title_2: 'Создание команды',
      title_3: 'Подключение бизнесов',
      btn: 'Зарегистрироваться',
      login: 'Войти'
    },
    main__content: {
      title: 'Что вы получаете:',
      subtitle: 'Простой и быстрый запуск собственного бизнеса',
      subtitle_2: 'Финансовую независимость',
      subtitle_3: `Всестороннюю поддержку наставника`,
      subtitle_4: 'Всестороннюю поддержку наставника',
      subtitle_4_dsc: 'Советы, помощь, личный пример и эффективная мотивация. Опытный бизнесмен работает на вашей стороне с первого дня',
      subtitle_5: 'Самостоятельное управление рабочим процессом',
      subtitle_5_Desc: 'Вы – хозяин своего бизнеса, и только вы решаете, как и сколько работать. А инструменты всегда под рукой – в личном кабинете',
      dsc: 'Готовые бизнес-схемы и материалы для рекламы, удобный личный кабинет и видеоинструкции, чтобы всем этим пользоваться',
      dsc_1: 'Онлайн-школа бизнеса, тренинги, вебинары, интенсивы – мы делимся знаниями и даем все инструменты для вашего роста',
      dsc_2: 'Активный и пассивный источники дохода, несколько видов прибыли одновременно – вы можете быть уверены в своем будущем',
      subtitle_4_Desc: 'Советы, помощь, личный пример и эффективная мотивация. Опытный бизнесмен работает на вашей стороне с первого дня',
      phoneTitle: 'Удаленную работу из любого уголка мира',
      phoneDsc: 'Путешествуйте, смотрите мир, выбирайте маршруты и страны. Где бы вы ни находились, ваш бизнес работает',
      befforeTitle: 'Высокоэффективное обучение',
      befforeDsc: 'Онлайн-школа бизнеса, тренинги, вебинары, интенсивы – мы делимся знаниями и даем все инструменты для вашего роста',
      lstTitle: `Право распоряжаться <br>
      собственным временем`,
      lstDsc: 'Мы уже создали инфраструктуру для вашего бизнеса. Начните сегодня и освободите время на действительно важные вещи завтра'
    },
    how: {
      title: 'Как начать зарабатывать вместе с WWP Capital',
      columnTitle_1: 'Команда клиентов',
      columnTitle_2: 'Команда партнеров',
      columnTitle_3: 'Подключение бизнесов',
      btn: 'Пригласить друзей',
      subtitle: 'Выбирайте, какой бизнес вести, или объединяйте все три',
      dsc_1: `Это все клиенты, приглашенные на кэшбэк-платформу лично вами. Чтобы пригласить друзей и знакомых, просто отправьте им свою реферальную ссылку. Они зарегистрируются и начнут совершать покупки, а вы – получать 15% от их кэшбэков.<br><br> При этом размер кэшбэка приглашенного не уменьшается. А если приглашенный приобретет GOLD-пакет, вы получаете бонус 17 евро. `,
      dsc_2: `Это масштабный бизнес с минимальными вложениями. Вы собираете уже не клиентов кэшбэк-платформы, а маркетологов-единомышленников и вместе составляете команду, чтобы продвигать IT-сервисы и строить бизнес. <br><br>Работа команды основана на дублировании успешных способов продвижения, которые от вас идут всем членам вашей команды.`,
      dsc_3: `Ваш бизнес с магазинами, салонами, ресторанами, брендами. Развивайте его одновременно с клиентской и/или партнерской командой или используете как самостоятельное решение.  <br><br>
                Вы приглашаете для регистрации на кэшбэк-платформе онлайн и офлайн-бизнесы и получаете проценты от комиссии со всех покупок, совершенных в данном магазине, салоне, ресторане и т.п. через платформу.`,
      additional_1: `Хотите зарабатывать на кэшбэке нескольких уровней клиентов? Приобретайте мини-франшизу!`,
      additional_2: `Этот вид бизнеса требует приобретения мини-франшизы, в которую входят IT-продукты, маркетинговые материалы, готовые бизнес-модели и обучение ведению бизнеса.`,
      additional_3: `Бизнесам это выгодно, так как они получают доступ к огромной площадке сбыта и 850 000+ потенциальных покупателей. А клиентам выгодно покупать и заказывать, так как с каждой покупки они получают хороший кэшбэк.`
    },

    video: {
      title: 'Расскажем самую суть за 2 минуты',
      subtitle: 'Мы записали видео, чтобы вы смогли легко во всём разобраться'
    },

    partner: {
      title: `Становитесь партнером и начинайте зарабатывать`,
      dsc: `Подберите для себя форму бизнеса, пройдите обучение и сделайте шаг в новый этап своей жизни – без ежедневных походов в офис, без будильников и начальников, без вечного подсчета денег от зарплаты до зарплаты. Готовы получать от жизни максимум? Выбирайте!`,
      btn: 'Подробнее о партнерстве'
    },

    money: {
      title: `Удобный вывод денег из&nbsp;системы`,
      subtitle: `Все заработанные вами деньги выводятся на ваш и только ваш личный счет. Любым удобным для вас способом.`,
      dsc: 'При выводе платежные системы взимают комиссию от 3% в зависимости от валюты перевода'
    },

    registration: {
      title: `Зарегистрируйтесь и начните свой бизнес прямо сейчас!`
    }

  },
  en: {
    menu: {
      title_1: 'Attracting customers',
      title_2: 'Creating a team',
      title_3: 'Connecting businesses',
      btn: 'Sign up',
      login: 'Sign in'
    },
    main__content: {
      title: 'What you are getting',
      subtitle: 'Simple and quick start-up of your own business',
      subtitle_2: 'Financial independence',
      subtitle_3: `Full mentor support`,
      subtitle_4: 'Comprehensive mentor support',
      subtitle_4_Desc: 'Advice, help, personal example and effective motivation.  An experienced businessman works on your side from first day',
      subtitle_5: 'Remote work from anywhere in the world',
      subtitle_5_Desc: 'Travel, see the world, choose routes and countries.  Wherever you are, your business is working',
      dsc: `Ready-made business charts and materials for advertising, a convenient personal account and video instructions to use it all`,
      dsc_2: `Active and passive sources of income, several types of profit at the same time - you can be confident in your future`,
      phoneTitle: 'Self-management of workflow',
      phoneDsc: 'You - the owner of the business, and only you decide how and how much to work. And the tools are always at hand - in a private office',
      befforeTitle: 'High performance learning',
      befforeDsc: 'Online business school, training, webinars, intensives - we share knowledge and give all the tools for your growth',
      lstTitle: `The right to manage your own time`,
      lstDsc: `We have already created an infrastructure for your business. Start today and free up the time for really important things for tomorrow`
    },
    how: {
      title: 'How to start making money with WWP Capital',
      columnTitle_1: 'Customer team',
      columnTitle_2: 'Partner team',
      columnTitle_3: 'Connection stores:',
      btn: 'Пригласить друзей',
      subtitle: 'Choose which business to run, or combine all three',
      dsc_1: `These are all clients invited to the cashback platform by you personally. To invite friends and acquaintances, just send them your referral link. They will register and start making purchases, and you will receive 15% of their cashbacks.<br><br> The size of the invited cache is not reduced. And if the invitee buys a GOLD package, you get a bonus of 17 euros. `,
      dsc_2: `This is a large-scale business with minimal investment. You are no longer collecting cashback clients, but like-minded marketers and together you make a team to promote IT services and build a business.<br><br> The work of the team is based on the promotion of successful ways that go from you to all members of your team. `,
      dsc_3: `Your business with shops, salons, restaurants, brands. Develop it simultaneously with a client and / or partner team or use it as a standalone solution. <br> <br> You invite online and offline businesses to register on the cashback platform and receive interest on commission from all purchases made in this store, salon, restaurant, etc. through the platform.`,
      additional_1: `Do you want to earn on cashback of several levels of clients? Buy a mini-franchise!`,
      additional_2: `This type of business requires the purchase of a mini-franchise, which includes IT products, marketing materials, ready-made business models and business training.`,
      additional_3: 'This is beneficial for businesses, as they gain access to a huge sales platform and 850,000+ potential buyers. And it’s profitable for customers to buy and order, since with each purchase they get a good cashback.'
    },

    video: {
      title: `Let's tell the most essence in 2 minutes`,
      subtitle: 'We recorded a video so that you could easily understand everything'
    },

    partner: {
      title: `Become a partner and start earning`,
      dsc: `Choose a form of business for yourself, go through training and take a step into a new stage of your life - without daily trips to the office, without alarm clocks and bosses, without eternal counting money from paycheck to paycheck.  Ready to get the most out of life?`,
      btn: 'Choose!'
    },

    money: {
      title: `Convenient withdrawal of&nbsp;money from the system`,
      subtitle: `All the money you earn is&nbsp;withdrawn to&nbsp;your account and only to&nbsp;your personal account. <br> Any way convenient for you. Further list of&nbsp;ways as&nbsp;now.`,
      dsc: 'When withdrawing, payment systems charge a commission of 3% depending on the currency of the transfer'
    },

    registration: {
      title: `Sign up and start your business right now!`
    }

  },
  ua: {
    menu: {
      title_1: 'Залучення клієнтів',
      title_2: 'Створення команди',
      title_3: 'Підключення бізнесів',
      btn: 'Зареєструватися',
      login: 'Увійти'
    },
    main__content: {
      title: 'Що ви отримуєте:',
      subtitle: 'Простий і швидкий запуск власного бізнесу',
      subtitle_2: 'Фінансову незалежність',
      subtitle_3: `Всебічну <br> підтримку наставника`,
      subtitle_3_dsc: 'Советы, помощь, личный пример и эффективная мотивация. Опытный бизнесмен работает на вашей стороне с первого дня',
      subtitle_4: 'Всебічну підтримку наставника',
      subtitle_4_Desc: 'Поради, допомогу, особистий приклад і ефективну мотивацію. Досвідчений бізнесмен працює на вашому боці з першого дня',
      subtitle_5: 'Віддалену роботу з будь-якого куточка світу',
      subtitle_5_Desc: 'Подорожуйте, дивіться світ, вибирайте маршрути і країни. Де б ви не знаходилися, ваш бізнес працює',
      dsc: `Готові бізнес-схеми і матеріали для реклами, зручний особистий кабінет і відеоінструкції, щоб усім цим користуватися`,
      dsc_2: `Активне і пасивне джерела доходу, кілька видів прибутку одночасно - ви можете бути впевнені в своєму майбутньому`,
      phoneTitle: `Самостійне управління робочим процесом`,
      phoneDsc: 'Ви - господар свого бізнесу, і тільки ви вирішуєте, як і скільки працювати. А інструменти завжди під рукою - в особистому кабінеті',
      befforeTitle: 'Високоефективне навчання',
      befforeDsc: 'Онлайн-школа бізнесу, тренінги, вебінари, інтенсиви - ми ділимося знаннями і даємо всі інструменти для вашого зростання',
      lstTitle: `Право розпоряджатися власним часом`,
      lstDsc: `Ми вже створили інфраструктуру для вашого бізнесу. Почніть сьогодні і звільніть час на дійсно важливі речі завтра`
    },
    how: {
      title: 'Як почати заробляти разом з WWP Capital',
      columnTitle_1: 'Команда клієнтів',
      columnTitle_2: 'Команда партнерів',
      columnTitle_3: 'Підключення бізнесів:',
      btn: 'Пригласить друзей',
      subtitle: 'Вибирайте, який бізнес вести, або об\'єднуйте всі три',
      dsc_1: `Це всі клієнти, запрошені на кешбек-платформу особисто вами. Щоб запросити друзів і знайомих, просто надішліть їм своє реферальне посилання. Вони зареєструються і почнуть здійснювати покупки, а ви-отримувати 15% від їх кешбек.<br><br> При цьому розмір кешбек запрошеного не зменшується. А якщо запрошений придбає GOLD-пакет, ви отримуєте бонус 17 євро.`,
      dsc_2: `Це масштабний бізнес з мінімальними вкладеннями. Ви збираєте вже не клієнтів кешбек-платформи, а маркетологів-однодумців і разом складаєте команду, щоб просувати IT-сервіси і будувати бізнес.<br><br> Робота команди заснована на дублювання успішних способів просування, які від вас йдуть всім членам вашої команди.`,
      dsc_3: `Ваш бізнес з магазинами, салонами, ресторанами, брендами. Розвивайте його одночасно з клієнтської і / або партнерської командою або використовуєте як самостійне рішення. <br> <br> Ви запрошуєте для реєстрації на Кешбек-платформі онлайн і офлайн-бізнеси і отримуєте відсотки від комісії з усіх покупок, здійснених в даному магазині, салоні, ресторані і т.п. через платформу.`,
      additional_1: `Хочете заробляти на кешбек декількох рівнів клієнтів? Купуйте міні-франшизу!`,
      additional_2: `Цей вид бізнесу вимагає придбання міні-франшизи, в яку входять IT-продукти, маркетингові матеріали, готові бізнес-моделі і навчання веденню бізнесу.`,
      additional_3: `Бізнесам це вигідно, тому що вони отримують доступ до величезної майданчику збуту і 850 000+ потенційних покупців. А клієнтам вигідно купувати і замовляти, так як з кожної покупки вони отримують хороший Кешбек.`
    },

    video: {
      title: 'Розповімо саму суть за 2 хвилини',
      subtitle: 'Ми записали відео, щоб ви змогли легко в усьому розібратися'
    },

    partner: {
      title: `Ставайте партнером і починайте заробляти`,
      dsc: `Підберіть для себе форму бізнесу, пройдіть навчання і зробіть крок в новий етап свого життя - без щоденних походів в офіс, без будильників і начальників, без вічного підрахунку грошей від зарплати до зарплати. Чи готові отримувати від життя максимум? Вибирайте!`,
      btn: 'Детальніше про партнерство'
    },

    money: {
      title: `Зручне виведення грошей з&nbsp;системи`,
      subtitle: `Всі зароблені вами гроші виводяться на ваш і тільки ваш особистий рахунок. Будь-яким зручним для вас способом.`,
      dsc: 'При виведенні платіжні системи стягують комісію від 3% в залежності від валюти переказу'
    },

    registration: {
      title: `Зареєструйтеся та почніть свій бізнес прямо зараз!`
    }
  },
  kz: {
    menu: {
      title_1: 'Клиенттерді тарту',
      title_2: 'Команда құру',
      title_3: 'Іскерлік байланыс',
      btn: 'Тіркелу',
      login: 'Кіру'
    },
    main__content: {
      title: 'Сіз не аласыз:',
      subtitle: 'Өз бизнесін оңай және жылдам іске қосу',
      subtitle_2: 'Қаржылық тәуелсіздік',
      subtitle_3: `Тәлімгерді <br>жан-жақты қолдау`,
      subtitle_4: 'Тәлімгерді жан-жақты қолдау',
      subtitle_3_dsc: 'Советы, помощь, личный пример и эффективная мотивация. Опытный бизнесмен работает на вашей стороне с первого дня',
      dsc: `Жарнамаға арналған дайын бизнес-схемалар мен материалдар, ыңғайлы жеке кабинет және бейнеқұрылымдар`,
      dsc_2: `Белсенді және пассивті табыс көздері, бір мезгілде бірнеше пайда түрі-сіз өз келешегіңізге сенімді бола аласыз`,
      subtitle_4_Desc: 'Кеңестер, көмек, жеке мысал және тиімді мотивация. Тәжірибелі кәсіпкер бірінші күннен бастап жұмыс істейді',
      subtitle_5: 'Әлемнің кез келген бұрышынан қашықтағы жұмыс',
      subtitle_5_Desc: 'Саяхат, әлемді қараңыз, бағыттар мен елдерді таңдаңыз. Қай жерде болсаңыз да, Сіздің бизнесіңіз жұмыс істейді',
      phoneTitle: 'Жұмыс процесін дербес басқару',
      phoneDsc: 'Сіз-өз бизнесіңіздің иесі, және тек сіз қалай және қанша жұмыс істеуді шешесіз. Құралдар әрқашан қол астында - Жеке кабинетте',
      befforeTitle: 'Жоғары тиімді оқыту',
      befforeDsc: 'Онлайн-бизнес мектебі, тренингтер, вебинарлар, қарқынды – біз білімдермен бөлісеміз және сіздің өсу үшін барлық құралдарды береміз',
      lstTitle: `Өз уақытын басқару құқығы`,
      lstDsc: `Біз сіздің бизнесіңіз үшін инфрақұрылым құрдық. Бүгін бастаңыз және Ертең шын мәнінде маңызды нәрселерге уақыт босатыңыз`
    },
    how: {
      title: 'WWW Capitalмен бірге қалай табыс табуға болады',
      columnTitle_1: 'Клиенттер командасы',
      columnTitle_2: 'Серіктестер командасы',
      columnTitle_3: 'Бизнесті қосу:',
      btn: 'Пригласить друзей',
      subtitle: 'Таңдау, қандай бизнес жүргізу, немесе барлық үш\'біріктіру',
      dsc_1: `Бұл кэшбэк платформасына сіз шақырған барлық клиенттер. Достар мен таныстарды шақыру үшін, оларға сілтеме жіберіңіз. Олар тіркелген және сатып ала бастайды, ал сіз-олардың кэшбэктерінің 15% алады.<br><br> Шақырылған кэшбэк өлшемі азаймайды. Ал егер шақырылған адам GOLD-топтама алса, сіз 17 евро бонус аласыз.`,
      dsc_2: `Бұл ең аз салымдармен ауқымды бизнес. Сіз кэшбэк-платформаның клиенттерін емес, маркетолог-пікірлестерді жинайсыз және бірге команда құрасыз.<br><br> Команда жұмысы сіздің командамыздың барлық мүшелеріне баратын табысты жылжыту тәсілдерін қайталау. `,
      dsc_3: `Дүкендер, салондар, мейрамханалар, брендтермен сіздің бизнесіңіз. Оны клиентпен және / немесе серіктес топпен бір уақытта жасаңыз немесе оны жеке шешім ретінде пайдаланыңыз. <br> <br> Сіз желіден тыс және оффлайн бизнесті cashback платформасында тіркелуге шақырасыз және осы дүкенде, салонда, мейрамханада және т.б. сатып алулардан комиссиялық сыйақы аласыз. платформа арқылы.`,
      additional_1: `Клиенттердің бірнеше деңгейлерін кэшбэк табу керек пе? Шағын франшизаны сатып алыңыз!`,
      additional_2: `Бизнестің бұл түрі IT-өнімдер, маркетингтік материалдар, дайын бизнес-модельдер және бизнесті жүргізуге оқыту кіретін шағын франшиза сатып алуды талап етеді.`,
      additional_3: `Бұл бизнес үшін тиімді, өйткені олар үлкен сату алаңына және 850,000+ әлеуетті сатып алушыларға қол жеткізе алады. Клиенттер үшін сатып алу және тапсырыс беру тиімді, өйткені әр сатып алған кезде олар жақсы ақшалай қаражаттарға ие болады.`
    },

    video: {
      title: '2 минуттың ішінде ең мәнін айтамыз',
      subtitle: 'Біз бәрін оңай түсіну үшін бейне жазып алдық'
    },

    partner: {
      title: `Серіктес болып, табыс табуды бастаңыз`,
      dsc: `Өзіңіз үшін бизнес формасын таңдап алыңыз, оқудан өтіп, өз өміріңіздің жаңа кезеңіне қадам жасаңыз –күнделікті кеңсеге бармай, қоңыраулы және бастықтарсыз, жалақыдан жалақыға дейін Мәңгілік ақша есептеусіз. Өмірінен максимум алуға дайын ба? Таңдау!`,
      btn: 'Әріптестік туралы толығырақ'
    },

    money: {
      title: `Жүйеден ыңғайлы ақша шығару`,
      subtitle: `Жиналған кэшбэк банктік карточкаға шығаруға болады. Яндекс.Ақша, QIWI әмиян немесе ePayments арқылы.`,
      dsc: 'Ақшаны алған кезде төлем жүйелері аударым валютасына байланысты 3% комиссия алады'
    },

    registration: {
      title: `Тіркелу және өз бизнесіңізді қазір бастаңыз!`
    }
  }
}
